import { inject } from '@angular/core';
import { BooktechAppService } from './booktech-app.service';

import { DATAID } from './data.service';
import { BtEvent } from './event.service';
import { MiscUtil } from '../util/misc.util';

import { LIB_VERSION_CODE, LIB_VERSION_NAME } from '../util/version';
import { NzModalRef } from 'ng-zorro-antd/modal';



export class ApiService {

  constructor(public bas: BooktechAppService ) {
    if(this.bas.envtest) console.log(MiscUtil.getLogText("ApiService.constructor"));


    if(this.bas.envtest) console.log("ApiService, hostname: " + (this.bas.nossr ? window.location.hostname : "SSR"));

    // this.refreshHostConfig();


    // this.bas.ds.get(DATAID.APP_CONFIG).subscribe(ac => {
    //   if(this.bas.envtest) console.log(MiscUtil.getLogText("ApiService.APP_CONFIG.subscribe, ac: "), ac);

    //   if (ac[DATAID.DS_SAVE_TIME]) {

    //   }
    // });

    this.bas.es.on(BtEvent.DS_INIT, () => {
      let urlVars = MiscUtil.getUrlVars(bas.LOC.path());
      this.bas.ds.set(DATAID.APP_URL_QUERY_PARAMS, urlVars);

      
      if(this.bas.envtest) console.log(MiscUtil.getLogText("ApiService.DS_INIT"));

      if(this.bas.envtest && this.bas.nossr) if(this.bas.envtest) console.log(MiscUtil.getLogText("ApiService.DS_INIT") + ", current config: ", this.bas.ds.config);

      if (this.bas.ds.config?.appConfig) {

        let isFrame = this.bas.nossr  && window.location !== window.parent.location;
        if(this.bas.envtest) console.log("ApiService.DS_INIT.isFrame: " + isFrame + ", standalone: " + this.bas.standalone + ", urlVars: ", urlVars  ,", login: ", this.bas.ds.login);
        
        let htmlTag = this.bas.DOC.getElementsByTagName("html")[0];
        
        if (isFrame) {
          htmlTag.classList.add("cbapi-iframe");
        } else htmlTag.classList.add("cbapi-not-iframe");

        htmlTag.classList.add("cbenv-" + (this.bas.envprod ? "prod" : "test"));
        if (this.bas.envdev) htmlTag.classList.add("cbenv-dev");

        if (urlVars.bttoken && (!this.bas.ds.login.success || (urlVars.btuid && urlVars.btuid != this.bas.ds.login?.user?.id))) { // isFrame && 
          // this.bas.ds.login = { success: true, accessToken: urlVars.bttoken };
          if(this.bas.envtest) console.log("checking logged in user, l.u.id: " + this.bas.ds.login?.user?.id + ", btuid: " + urlVars.btuid);
          this.checkLoggedInUser({}, { token:  urlVars.bttoken }).then((res) => {
            if (res.success) { 
              if(this.bas.envtest) console.log("checkLoggedInUser, user logged in,  reloading page ??");
              //TODO: legge inn en counter &reloadCount=1++ for å sørge for at det ikke blir evig reload?
              this.bas.nossr && window.location.reload();
            } else {
              
              this.bas.es.trigger(BtEvent.APP_READY);
        
            }
          });
        } else {


            
          this.bas.es.trigger(BtEvent.APP_READY);
          

          // if (this.bas.standalone) return; 
          
          setTimeout(() => {
            this.refreshAppConfig();
          }, 300)

        }


      } else {
        setTimeout(() => {
          this.refreshAppConfig();
        }, 10)
        // this.refreshAppConfig();

      }





      
    })
    
    
   
  }


  async refreshAppConfig() {


    var cid = this.bas.ds.findCid('refreshAppConfig');
      
    if(this.bas.envtest) console.log(MiscUtil.getLogText("ApiService.refreshAppConfig, cid: " + cid));

    let currentConfig = this.bas.ds.config?.appConfig;
    let lastUpdated = currentConfig ? currentConfig.updatedLong : 0;

    let urlVars = MiscUtil.getUrlVars(this.bas.LOC.path());
    let siteQueueUuid = urlVars["siteQueueUuid"]
    let di = this.bas.ds.device;
    if(this.bas.envtest) console.log("ApiService.refreshAppConfig, di: ", di);
    if (!siteQueueUuid) {
      siteQueueUuid = di.siteQueueUuid || "";
    } else {
      di.siteQueueUuid = siteQueueUuid;
      this.bas.ds.save(DATAID.APP_DEVICE, di).then(() => {
         if(this.bas.envtest) console.log("ApiService.refreshAppConfig, APP_DEVICE SAVED: ", di);
      });
    }

    let params:any = { 
      aType: "app",
      action: "ping",
      hostname: this.bas.nossr ? window.location.hostname : "",
      // lastUpdate: lastUpdated,
      libVersion: 7,
      appType: this.bas.settings.appType || "btng",
      versionCode: this.bas.version.code || LIB_VERSION_CODE,
      nativeAppVersionCode: this.bas.version.name || LIB_VERSION_NAME, //TODO:v7 : DONE? dette skal være app versjon og ikke lib
      cid: cid
    };
    
    if (siteQueueUuid) {

   
      params.siteQueueUuid = siteQueueUuid;
    }

    if (!this.bas.standalone) {
      params.lastUpdate = lastUpdated;
    }

    if (params.appType === "booktech") {

    }


    if(this.bas.envtest) console.log("ApiService.refreshAppConfig, params: ", params);

    let res = await this.bas.ws.json(params, { });

    if(this.bas.envtest) console.log("ApiService.refreshAppConfig.then: ", res);

    if (this.bas.standalone) return;

    if (res.success && res.appConfig) {
      if (!res.cid) {
        res.cid = "root";
        res.company = {
          username: "root",
          root: true
        }
      }
      this.bas.ds.save(DATAID.APP_CONFIG, res).then(() => {

        if(this.bas.envtest) console.log("config updated, reloading page, ac: ", res);
        
        if (this.bas.standalone) {
          this.bas.es.trigger(BtEvent.APP_READY);
        } else {
          if (this.bas.nossr) window.location.reload();
          return;
        }
        
      

        if (this.bas.es.isReady) {
          //TODO: gi beskjed om at siden må oppdateres? 
        } else {
          this.bas.es.trigger(BtEvent.APP_READY);
        }
        
      });
    } else {



      if (this.bas.es.isReady) {
        //TODO: gi beskjed om at siden må oppdateres? 
      } else {
        this.bas.es.trigger(BtEvent.APP_READY);
      }
      
    }


      // this.updateInitData(res);

    // };
    // .catch((err) => {
    //   if(this.bas.envtest) console.log("ApiService.refreshAppConfig.failed, err ", err);
      
    // });

  }









  async login(params:any = {}, opts:any = {}):Promise<any> {

    if (this.ffb("backend.api.auth.login")) {
      return this.blogin(params, opts);
    }

    MiscUtil.extend(params, {
      aType: "auth",
      action: "login",
    });

    return this.bas.ws.json(params, opts).then(async (res) => {

      if(this.bas.envtest) console.log("ApiService.login: ", res);

   

      return this.bas.ds.save(DATAID.APP_LOGIN, res).then((saveRes) => {
        if (res.success) {
          if(this.bas.envtest) console.log("login.success,  saveRes: ", saveRes);
          // window.location.reload();
          let lang = this.bas.ds.findLang(true);
          if (lang != res.user.languageCode) {
            this.bas.us.setLanguage(res.user.languageCode);
          }
          
        }
        return res;
      });

      // return res;

    }).catch((err) => {
      if(this.bas.envtest) console.log("ApiService.login.failed, err ", err);
    });

  }

  checkLoggedInUser(params:any = {}, opts:any = {}):Promise<any> {

    return new Promise<any>((success, rej) => {

      MiscUtil.extend(params, {
        aType: "auth",
        action: "checkLoggedInUser",
      });
  
      let headers = opts.token || opts.checkRefresh ?  {
        "cb-auth-token": opts.token || this.bas.ds.login.refreshToken,
      } : { };
  
      this.bas.ws.json(params, { 
        checkSuccess: false,
        headers: headers
      }).then( (res) => {
  
        if(this.bas.envtest) console.log("ApiService.checkLoggedInUser: ", res);
  
        if (res.success) {

          this.bas.ds.save(DATAID.APP_LOGIN, res).then(() => {
            success(res);
          });
  
        } else {
          success(res);
        }
        
        // return res;
  
      }).catch((err) => {
        if(this.bas.envtest) console.log("ApiService.checkLoggedInUser.failed, err ", err);
        rej({ success: false });
      });

    });


  }

  logout():Promise<any> {
    let refreshToken = this.bas.ds.login.refreshToken;
    this.bas.ds.save(DATAID.APP_LOGIN, { success: false});

    return this.bas.ws.json(
      { aType: "auth", action: "logout" },
      { 
        headers: { "cb-auth-token": refreshToken },
        excludeLoginHeaders: true,
        checkAuthStatus: false
      }
    ).then((res) => {

      if(this.bas.envtest) console.log("ApiService.logout: ", res);

      
      return res;

    }).catch((err) => {
      if(this.bas.envtest) console.log("ApiService.logout, err ", err);
    });

  }

  lostPassword(params:any = {}, opts:any = {}):Promise<any> {

    MiscUtil.extend(params, {
      aType: "auth",
      action: "lostPassword",
      platform: params.platform || this.bas.settings.appId || "cbapi5",
      useDev: this.bas.envdev ? true : undefined
    });

    return this.bas.ws.json(params, { }).then((res) => {

      if(this.bas.envtest) console.log("ApiService.lostPassword: ", res);

      // this.bas.ds.save(DATAID.APP_LOGIN, res);

      return res;

    }).catch((err) => {
      if(this.bas.envtest) console.log("ApiService.lostPassword.failed, err ", err);
    });

  }


  apiPageShowMessage(qps:any) {
    qps = qps || { };
    let mkInfo = qps["cbapi-info"];
    let mkError = qps["cbapi-error"];

    if (mkInfo || mkError) {
      let mk = mkError 
        ? "app.lib.api.error." + mkError 
        : "app.lib.api.info." + mkInfo
      ;
      console.log("mk: " + mk);
      
      let message = this.bas.ui.actrans(mk);
      if (mkError || message)  {
        if (mkError && !message) message = this.bas.ui.actrans("app.lib.error.generic") || "En feil har oppstått";

        let modal:NzModalRef | void = this.bas.ui.modal(
          mkError ? "error": "info",
          this.bas.ui.actrans(mkError 
            ? "app.lib.common.error"
            : "app.lib.common.info"
          ),
          message
         
        );

        if (modal) modal.afterClose.subscribe(() => {
        
        });

        // () => {
        //   this.processRequest();
        // }

        return;
      }
    

    
      
    }
  }

  // Feature flag check
  ffo(path:string):any {
    let ff = this.bas.ds.config?.appConfig?.ff || { };
    // if(this.bas.envtest) console.log("ApiService.ffo: ", ff);

    let value = MiscUtil.getOwnNestedProperty(ff, path);
   
    // if(this.bas.envtest) console.log("ApiService.ffo.value: ", value);

    return value !== undefined ? value : { };
  }
  ffb(path:string, defaultValue:boolean = false):boolean {
    // On test environments, allow URL parameter override: ?backend.search.next=true
    if (this.bas.envtest && this.bas.nossr) {
      try {
        let params = new URLSearchParams(window.location.search);
        let override = params.get(path);
        if (override !== null) return override === "true";
      } catch (e) { }
    }

    let ff = this.bas.ds.config?.appConfig?.ff || { };

    let value = MiscUtil.getOwnNestedProperty(ff, path);

    if (value === undefined) return defaultValue;
    return value === true;
  }
  // ffv(value:string|boolean|undefined):boolean {
  //   // let ff = this.bas.ds.config?.appConfig?.ff || { };
  //   // if(this.bas.envtest) console.log("ApiService.ffb: ", ff);

  //   // let value = MiscUtil.getOwnNestedProperty(ff, path);
   
  //   if(this.bas.envtest) console.log("ApiService.ffv.value: ", value);

  //   if (typeof value === "boolean") {
  //     return value;
  //   }
  //   if (typeof value === "undefined") {
  //     return false;
  //   }

  //   if (typeof value === "string") {
  //     // TODO: støtte for env verdier eller er det bare dumt? 
  //     return value === "true";
  //   }

  //   return false;
  // }


  // ==========================================================================
  // NEW BACKEND (api.cloudbooking.io) support
  // ==========================================================================


  async blogin(params:any = {}, opts:any = {}):Promise<any> {

    let body:any = {
      username: params.username,
      password: params.password
    };

    let callOpts = MiscUtil.extend({ excludeLoginHeaders: true, checkSuccess: true }, opts);

    let res = await this.bas.ws.bjson('auth', 'login', body, callOpts);

    if(this.bas.envtest) console.log("ApiService.blogin: ", res);

    if (res && (res.success || res.accessToken)) {
      let loginData = MiscUtil.extend({ }, res);
      if (res.accessToken) {
        loginData.success = true;
        loginData.user = loginData.user || {
          id: res.userId,
          username: res.username,
          email: res.email,
          languageCode: res.language,
          timeZone: res.timeZone,
          role: res.role
        };
        loginData.company = loginData.company || { username: res.cid };
      }

      await this.bas.ds.save(DATAID.APP_LOGIN, loginData);

      let lang = this.bas.ds.findLang(true);
      if (loginData.user && lang != loginData.user.languageCode) {
        this.bas.us.setLanguage(loginData.user.languageCode);
      }

      return loginData;
    }

    return res;

  }

  async bcheckLoggedInUser(opts:any = {}):Promise<any> {

    let token = opts.token;
    let checkRefresh = opts.checkRefresh;

    if (!token && !checkRefresh) {
      token = this.bas.ds.login.accessToken;
    } else if (checkRefresh) {
      token = this.bas.ds.login.refreshToken;
    }

    let headers:any = { };
    if (token) headers["Authorization"] = "Bearer " + token;

    let res = await this.bas.ws.bjson('auth', 'check', { }, {
      method: 'get',
      excludeLoginHeaders: true,
      headers: headers,
      checkSuccess: false
    });

    if(this.bas.envtest) console.log("ApiService.bcheckLoggedInUser: ", res);

    if (res && (res.success || res.userId || res.id)) {
      let loginData = MiscUtil.extend({ }, res);
      if (!loginData.success) loginData.success = true;
      if ((res.userId || res.id) && !loginData.user) {
        loginData.user = {
          id: res.userId || res.id,
          username: res.username,
          email: res.email,
          languageCode: res.language,
          timeZone: res.timeZone,
          role: res.role
        };
      }
      if (res.cid && !loginData.company) {
        loginData.company = { username: res.cid };
      }

      await this.bas.ds.save(DATAID.APP_LOGIN, loginData);
      return loginData;
    }

    return res;

  }

  async blogout():Promise<any> {
    let refreshToken = this.bas.ds.login.refreshToken;
    this.bas.ds.save(DATAID.APP_LOGIN, { success: false});

    let res = await this.bas.ws.bjson('auth', 'logout', { refreshToken }, {
      excludeLoginHeaders: true,
      checkSuccess: false
    });

    if(this.bas.envtest) console.log("ApiService.blogout: ", res);

    return res;

  }

  async blostPassword(params:any = {}, opts:any = {}):Promise<any> {

    let body:any = {
      username: params.username,
      platform: params.platform || this.bas.settings.appId || "cbapi5",
      returnUri: params.returnUri || (this.bas.nossr ? window.location.href : "")
    };

    let callOpts = MiscUtil.extend({ checkSuccess: true }, opts);

    let res = await this.bas.ws.bjson('auth', 'lost-password', body, callOpts);

    if(this.bas.envtest) console.log("ApiService.blostPassword: ", res);

    return res;

  }


}
